import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Input, Form, Row, Popover } from 'antd';
import { useTranslation } from 'react-i18next';
import { PrinterOutlined, MailOutlined } from '@ant-design/icons';

const PrintSignModal = ({
  openLastStepModal,
  printContract,
  signContract,
  isDownloading,
  downloading,
  contract,
  form
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        title={t('contracts.modal.title')}
        centered
        open={openLastStepModal}
        closable={false}
        width={900}
        footer={[
          <div style={{ textAlign: 'center', fontWeight: 700 }}>
            {t('contracts.modal.modal_obligation')}
          </div>
        ]}
      >
        <div style={{ textAlign: 'center', fontWeight: 700 }}>
          {t('contracts.modal.modal_succes')}
        </div>
        <Row justify="space-around" style={{ marginTop: 40, marginBottom: 40 }}>
          <Button
            onClick={() =>
              signContract(
                contract.amendment.length
                  ? 'signPrintAmendment'
                  : 'signPrintContract',
                contract.amendment.length
                  ? contract.amendment[contract.amendment.length - 1]._id
                  : null
              )
            }
            type="primary"
            style={{
              width: 'auto',
              padding: '4px 15px'
            }}
            loading={downloading}
          >
            <span
              style={{
                display: 'inline'
              }}
            >
              {t('contracts.form.title.action.sign_mail')}
            </span>
            <MailOutlined />
          </Button>
          <Popover content={t('contracts.modal.popover')}>
            <Button
              onClick={() =>
                printContract(
                  contract.amendment.length
                    ? 'signPrintAmendment'
                    : 'signPrintContract',
                  contract.amendment.length
                    ? contract.amendment[contract.amendment.length - 1]._id
                    : null
                )
              }
              type="primary"
              style={{
                width: 'auto',
                padding: '4px 15px'
              }}
              loading={isDownloading}
            >
              <span
                style={{
                  display: 'inline'
                }}
              >
                {t('contracts.form.title.action.print_contract_action')}
              </span>
              <PrinterOutlined />
            </Button>
          </Popover>
        </Row>
        {contract && contract?.customer?.email ? (
          []
        ) : (
          <div>
            <div>{t('contracts.modal.email')}</div>
            <Form form={form}>
              <Form.Item
                hasFeedback={form.validateFields()}
                name="email"
                label={<MailOutlined />}
                rules={[
                  {
                    required: true,
                    type: 'email'
                  }
                ]}
              >
                <Input
                  style={{ width: '200px' }}
                  placeholder={t('insurers.form.owner_email')}
                />
              </Form.Item>
            </Form>
          </div>
        )}
      </Modal>
    </>
  );
};

PrintSignModal.propTypes = {
  openLastStepModal: PropTypes.bool.isRequired,
  printContract: PropTypes.func.isRequired,
  signContract: PropTypes.func.isRequired,
  isDownloading: PropTypes.bool.isRequired,
  downloading: PropTypes.bool.isRequired,
  contract: PropTypes.shape({
    amendment: PropTypes.arrayOf(PropTypes.string),
    previous_contract: PropTypes.string,
    customer: PropTypes.shape({
      email: PropTypes.string
    })
  }).isRequired,
  form: PropTypes.shape({
    validateFields: PropTypes.func
  }).isRequired
};

export default PrintSignModal;
